import React, { useEffect, useState } from 'react';
import { Typography, Button, Box, IconButton, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomDialog from '../commoncomponents/CustomDialog';
import { CancelWorkOrder } from './BasicDetails';
import { decryptDataForHyperlink, updateOutsourceDetails, updateWorkOrderStatus } from '../../redux/actions/workOrderActionTypes';
import { useDispatch, useSelector } from 'react-redux';
import { mandatoryFields } from '../../redux/actions/assetActions';

const BottomButtonsforWorkOrder = ({
    page = '',
    buttonAttributes,
    enableAuthorizeButton = false,
    saveButton = false,
    saveClick,
    authorizeButton = false,
    authorizeClick,
    continueButton = true,
    cancelWo = false,
    onEnableChange,
    enabel,
    onConfirm,
    outsourseSubmitBtn = false,
    outsourceHandleConfirm,
    disableSave = false,
    disableSubmitBtn = false,
    saveButtonName,
    basicdetailsOnSubmit,
    isbasicdetailsTab = false,
}) => {
    
    const navigate = useNavigate();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [cancelWorkorderDialog, setCancelWorkorderDialog] = useState(false);
    const [cancel, setCancel] = useState(cancelWo);
    const findPageName = buttonAttributes.find((item) => item.currentPageName === page) || {};
    const dispatch = useDispatch();
     const location = useLocation();
    const decryptData = useSelector((state)=>state?.hyperLinkData)
         
    const { setPage, cancelButtonName, continueButtonName, backButtonName, backButton, previousPageName, cancelWO } = findPageName;

    const status = useSelector((state) => state?.workOrderStatus?.status);
    const checkcancelWOStatus = status === "Open" || status === "In Progress" || status === "Scheduled" || status === "In Progress-Outsource" ? true : false;

//    // Function to import the key from a Base64 string
//   async function importKey(base64Key) {
//       const rawKey = base64ToArrayBuffer(base64Key);
//       return await crypto.subtle.importKey('raw', rawKey, 'AES-GCM', true, ['decrypt']);
//   }
  
//   // Function to convert Base64 string to ArrayBuffer
//   function base64ToArrayBuffer(base64) {
//       const binaryString = window.atob(base64);
//       const len = binaryString.length;
//       const bytes = new Uint8Array(len);
//       for (let i = 0; i < len; i++) {
//           bytes[i] = binaryString.charCodeAt(i);
//       }
//       return bytes.buffer;
//   }
  
//   // Function to decrypt data using AES-GCM
//   async function decryptDataKey(key, encryptedData, iv) {
//       const decrypted = await crypto.subtle.decrypt(
//           {
//               name: "AES-GCM",
//               iv: iv,
//           },
//           key,
//           encryptedData
//       );
  
//       const decoder = new TextDecoder();
//       return JSON.parse(decoder.decode(decrypted));
//   }
  
//   // Retrieve the encrypted state, IV, and key from the URL
//   const queryParams = new URLSearchParams(location?.search);
//   const encryptedStateString = queryParams.get("state");
//   const ivString = queryParams.get("iv");
//   const keyString = queryParams.get("key");
  
//   const getDecryptData = () =>{
//       try {
//           if (encryptedStateString && ivString && keyString) {
//               // Convert the Base64 encoded data, IV, and key back to ArrayBuffer
//               const encryptedData = base64ToArrayBuffer(decodeURIComponent(encryptedStateString));
//               const iv = base64ToArrayBuffer(decodeURIComponent(ivString));
          
//               // Import the encryption key
//               importKey(decodeURIComponent(keyString)).then((key) => {
//                   // Decrypt the data
//                   decryptDataKey(key, encryptedData, iv).then((decryptedData) => {
//                       dispatch(decryptDataForHyperlink("DECRYPT_DATA_REDUCERS_HYPERLINK",decryptedData))
//                   }).catch((error) => {
//                       console.error("Decryption failed:", error);
//                   });
//               });
//           } else {
//               console.log("Encrypted state, IV or key not found in the URL");
//           }
//       } catch (error) {
//           console.log("Decryption failed:", error)
//       }
//   }
  
//       useEffect(()=>{
//           getDecryptData()
//       },[])
    

    const handleCloseCancelDialog = () => {
        setShowDeleteDialog(false);
    };

    const handleConfirmCustomCancel = (name) => {
        setCancelWorkorderDialog(false);
        if (name === 'no') {
            onEnableChange("no")
        };
    };
    
    const handleConfirmCancel = async () => {
        if(location?.state?.isdepartmentViewMode === true){
            dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
            dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
            dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: "", percentage: 0 }))
            dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
            dispatch({ type: "SERVICE&CATEGORY_TYPE", payload: {} })
            setShowDeleteDialog(false);
            navigate('/Userdeptdashboard', { state: { isChange: location.state.isChange,year:location.state.year,month:location.state.month,activetabdeparment:8 } });
            dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
        }else
        {
            dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
            dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
            dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: "", percentage: 0 }))
            dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
            dispatch({ type: "SERVICE&CATEGORY_TYPE", payload: {} })
            setShowDeleteDialog(false);
            navigate('/workorder', { state: { isChange: location?.state?.isChange || decryptData?.isChange || "", year:location?.state?.year || decryptData?.year || "", month:location?.state?.month || decryptData?.month || "" } });
            dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
        }
     
    };


    const handleConfirmOutsourse = () => {
        outsourceHandleConfirm();
    };

    const handleBackClick = () => {
        setPage(previousPageName);
        dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
    };

    const handleCancelClick = (e) => {
        setShowDeleteDialog(true);
    };

    const handleCustomCancelClick = (e) => {
        setCancel(e.target.name === 'cancelWo' ? true : false)
        setCancelWorkorderDialog(true);
        setCancel(false);
    };

    return (
        <>
            <Box pt={{ xs: 3, md: 8 }} sx={{ display: 'flex', justifyContent: 'space-between' }} flexWrap={'wrap'}>
                {backButton && <Box >
                    <IconButton aria-label="previous" onClick={handleBackClick} >
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant='labelSm' color={'text.primary'}>{backButtonName}</Typography>
                </Box>
                }
                <Box sx={{ display: 'inline-flex', gap: 2 }}>
                    <Button variant='outlined' onClick={handleCancelClick} name='cancel' >{cancelButtonName}</Button>
                    {checkcancelWOStatus &&
                        cancelWo && <Button variant='outlined' onClick={handleCustomCancelClick} name='cancelWo' disabled={enabel}>{cancelWO}</Button>
                    }
                    {saveButton && <Button variant='contained' onClick={saveClick} disabled={disableSave}>{saveButtonName}</Button>}


                    <CancelWorkOrder
                        open={cancelWorkorderDialog}
                        onClose={handleConfirmCustomCancel}
                        onConfirm={onConfirm}
                    />
                    {outsourseSubmitBtn && <Button variant='contained' onClick={handleConfirmOutsourse} disabled={disableSubmitBtn}>Submit</Button>}
                    {
                        authorizeButton ?
                            <Button variant='contained' disabled={enableAuthorizeButton} onClick={authorizeClick}>{continueButtonName}</Button> :
                            continueButton ?
                                // <Button variant='contained' disabled={enableAuthorizeButton} type="submit">{continueButtonName}</Button> : null
                                 <Button variant='contained' disabled={enableAuthorizeButton} type= {isbasicdetailsTab ? "button" : "submit"} onClick={ isbasicdetailsTab ? basicdetailsOnSubmit  : null}>{continueButtonName}</Button> : null
                    }
                </Box>
            </Box>

            <CustomDialog
                open={showDeleteDialog}
                onClose={handleCloseCancelDialog}
                onConfirm={() => { handleConfirmCancel(cancel) }}
                content="Are you sure you want to cancel?"
                cancelBtn="No"
                confirmBtn="Yes"
            />

        </>
    );
};

export default BottomButtonsforWorkOrder;
